// import React, { Fragment, FunctionComponent } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faRobot } from "@fortawesome/free-solid-svg-icons";
// import { Graphics, Description } from "../styles/agency-income-metrics-styles";

// const Robot: FunctionComponent<unknown> = () => (
//   <Fragment>
//     <Graphics>
//       <FontAwesomeIcon icon={faRobot} />
//     </Graphics>
//     <Description>
//       This could buy you: <br /> <span>a robot</span>!
//     </Description>
//   </Fragment>
// );

// export default Robot;
